import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private showLoadingSubject = new Subject<string>();

  public showLoading$ = this.showLoadingSubject.asObservable();

  private hideLoadingSubject = new Subject<string>();

  public hideLoading$ = this.hideLoadingSubject.asObservable();

  private showGallerySubject = new Subject<string>();

  public showGallery$ = this.showGallerySubject.asObservable();

  showLoadingComponent(loadId: string) {
    this.showLoadingSubject.next(loadId);
  }

  hideLoadingComponent(loadId: string) {
    this.hideLoadingSubject.next(loadId);
  }
}
